import React from "react";
import { Segmented, Tag, Tooltip } from "antd";
import { LockOutlined, TeamOutlined } from "@ant-design/icons";

// Saved replies are public (everyone in the account) or private (only the person who saved it). Older replies
// without a visibility are public.
export const visibilityOf = item => (item && item.visibility === "private" ? "private" : "public");

// New replies start as "Only me" everywhere. Only the person who added a public reply can make it private
// (`privateDisabled` for everyone else).
export const DEFAULT_VISIBILITY = "private";

export const VisibilityChoice = ({intl, value, onChange, size, privateDisabled = false}) => (
    <Segmented
        size={size}
        value={value}
        onChange={onChange}
        options={[
            {
                value: "private",
                disabled: privateDisabled,
                label: (
                    <Tooltip title={privateDisabled ? intl.formatMessage({id: "savedReplies.onlyOwnerPrivate", defaultMessage: "Only the person who added it can make it private"}) : null}>
                        <span className="visibility-option"><LockOutlined/> {intl.formatMessage({id: "savedReplies.private", defaultMessage: "Only me"})}</span>
                    </Tooltip>
                )
            },
            {value: "public", label: <span className="visibility-option"><TeamOutlined/> {intl.formatMessage({id: "savedReplies.public", defaultMessage: "Everyone in the team"})}</span>}
        ]}
    />
);

export const VisibilityTag = ({intl, item}) => (visibilityOf(item) === "private" ? (
    <Tooltip title={intl.formatMessage({id: "savedReplies.privateHint", defaultMessage: "Only you see this reply"})}>
        <Tag icon={<LockOutlined/>} className="visibility-tag is-private">{intl.formatMessage({id: "savedReplies.privateShort", defaultMessage: "Private"})}</Tag>
    </Tooltip>
) : (
    <Tooltip title={intl.formatMessage({id: "savedReplies.publicHint", defaultMessage: "Everyone in your team sees and can change this reply"})}>
        <Tag icon={<TeamOutlined/>} className="visibility-tag is-public">{intl.formatMessage({id: "savedReplies.publicShort", defaultMessage: "Public"})}</Tag>
    </Tooltip>
));
